import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { schedulesApi, type MemberListParams } from '../api/schedules-api';

import { scheduleKeys } from './schedule-keys';

export function scheduleMembersQueryOptions(id: string, params: MemberListParams) {
  return queryOptions({
    queryKey: scheduleKeys.memberList(id, params),
    queryFn: () => schedulesApi.members(id, params),
    placeholderData: keepPreviousData,
  });
}

/** One page of the pool, ordered by position then product id. */
export function useScheduleMembers(id: string, params: MemberListParams) {
  return useQuery(scheduleMembersQueryOptions(id, params));
}
